<template>
  <div class="history" @click="onClose" id="history">
    <div class="history-inner">
      <div class="history-hd" v-if="records.length">
        <strong class="history-title">{{ TLang('最近搜过', 'quick') }}</strong>
        <van-icon class="history-delete" name="delete" @click="onRemove"></van-icon>
      </div>
      <div class="history-bd limitTwo" v-if="records.length">
        <span v-for="(record, index) in records" :key="index" @click.stop="onSearch($event)">{{ record }}</span>
      </div>
      <div class="history-hd" v-if="wordList.length && !getBFD()">
        <strong class="history-title">{{ TLang('搜索发现', 'quick') }}</strong>
      </div>
      <div class="history-searchFind limitTwo" v-if="wordList.length && !getBFD()">
        <span
          v-for="(record, index) in wordList"
          :key="index"
          :class="{
            'searchFind-FirstType': record.linkType === 3,
            'searchFind-Second': record.linkType === 2,
          }"
          @click.stop="onWordListSearch(record)"
        >
          <img :src="FirstTypeImg" v-if="record.linkType === 3" />
          <img :src="SecondTypeImg" v-if="record.linkType === 2" />
          {{ record.word }}
        </span>
      </div>
      <div class="history-hd" v-if="recommandGoods.length && !getBFD()">
        <strong class="history-title">{{ TLang('热门推荐', 'quick') }}</strong>
      </div>
      <div class="history-searchFind" v-if="recommandGoods.length && !getBFD()">
        <div class="recommandGoods">
          <div class="goods-item" @click.stop="onRecommendSearch(record)" v-for="(record, index) in recommandGoods" :key="index">
            <div class="img"><img :src="record.imgUrl" alt="" /></div>
            {{ record.showName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryString, gioClickHandle, getCookieAddressInfo, checkUnifyShop, unionFlag } from '../utils';
import { getSearchUrl, getWordList, getRecommendGoods } from '@/assets/js/api';
import { BFD_checkApp } from '@/utils/bfdApp.js';
import FirstTypeImg from '@/assets/imgs/FirstType.png';
import SecondTypeImg from '@/assets/imgs/secondType.png';
export default {
  name: 'pastRecord',
  data() {
    return {
      city: getCookieAddressInfo('cityId') || getQueryString('city') || 145,
      FirstTypeImg: FirstTypeImg,
      SecondTypeImg: SecondTypeImg,
      wordList: [],
      recommandGoods: [],
    };
  },
  created() {
    this.getWord();
    this.getRecommend();
  },
  computed: {
    records() {
      let LOCALRECORD = localStorage.getItem('record');
      let arr = [];
      // let oldArr=[];

      if (LOCALRECORD) {
        arr = JSON.parse(LOCALRECORD);
        // arr=oldArr.slice(0,10);
      }
      return arr;
    },
  },
  methods: {
    getBFD() {
      // 判断是否是甄选
      const origin = window.location.origin
      if (origin.indexOf('m-zx') > -1) {
        return false
      }
      const union = unionFlag() || sessionStorage.getItem('dffl_union');
      return union && !checkUnifyShop();
    },
    async getWord() {
      if (this.getBFD()) return;
      getWordList({
        ignore: false,
        platform: 1,
        scene: 1,
      }).then((res) => {
        if (res && res.data && res.data.body) {
          this.wordList = res.data.body;
        }
      });
    },
    async getRecommend() {
      if (this.getBFD()) return;
      getRecommendGoods({
        key: 'search.category.scope',
      }).then((res) => {
        if (res && res.data && res.data.data && res.data.data.value) {
          this.recommandGoods = res.data.data.value;
        }
      });
    },
    onRecommendSearch(ev) {
      const data = {
        key: ev.key,
        city: this.city,
      };
      this.$emit('handlerSearch', data, false);
    },
    onWordListSearch(ev) {
      if (ev.linkType === 1) {
        const data = {
          key: ev.linkParameter.innerWord,
          city: this.city,
        };
        this.$emit('handlerSearch', data, false);
      } else if (ev.linkType === 2) {
        // 实体商品
        if (ev.linkParameter.goodsType == 1) {
          const unionCode = unionFlag() || sessionStorage.getItem('dffl_union');
          window.df_sdk_common.location.href = `/tmall/product/detail?union=${unionCode}&cid=${ev.linkParameter.categoryId}&gid=${ev.linkParameter.goodsId}`;
        } else if (ev.linkParameter.goodsType == 2) {
          // 电子券商品
          window.df_sdk_common.location.href = `/dfmall/vouchersDetail?id=${ev.linkParameter.spuId}`;
        } else {
          this.$emit('handlerSearch', data, false);
        }
      } else if (ev.linkType === 3) {
        // 跳转cms活动页
        const unionCode = unionFlag() || sessionStorage.getItem('dffl_union');
        if (ev.linkParameter.pageCode) {
          window.df_sdk_common.location.href = `/bfd-pagesite?pageCode=${ev.linkParameter.pageCode}&union=${unionCode}`;
        } else if (ev.linkParameter.activityId) {
          // 跳转ads
          window.df_sdk_common.location.href = `/tmall/activity/detail/${ev.linkParameter.activityId}`;
        } else {
          this.$emit('handlerSearch', data, false);
        }
      }
    },
    async onSearch(ev) {
      const res = await getSearchUrl({
        keyword: ev.target.innerText,
        platform: BFD_checkApp() ? 3 : 1,
      });
      //触发埋点
      let pathName = window.location.pathname;
      let channelName = '全部';
      if (pathName.indexOf('home') > -1) {
        channelName = '全部';
      } else if (getQueryString('productTypes')) {
        channelName = getQueryString('productTypes');
      }

      if (res && res.data && res.data.body && res.data.body.linkUrl) {
        gioClickHandle('DF_elementClick', {
          df_channle: channelName,
          df_pagename: '搜索页',
          df_modulename: '搜索历史',
          df_elementname: '搜索历史词',
          df_searchKeyword: ev.target.innerText,
          df_pageType: '词链',
        });
        // 词链跳转
        window.df_sdk_common.location.href = res.data.body.linkUrl;
      } else {
        gioClickHandle('DF_elementClick', {
          df_channle: channelName,
          df_pagename: '搜索页',
          df_modulename: '搜索历史',
          df_elementname: '搜索历史词',
          df_searchKeyword: ev.target.innerText,
        });
        const data = {
          key: ev.target.innerText,
          city: this.city,
        };
        this.$emit('handlerSearch', data, false);
      }
    },
    onRemove() {
      localStorage.removeItem('record');
    },
    onClose() {
      this.$emit('handlerBlur', false);
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.history {
  border-top: 1px solid #e5e5e5;
  position: absolute;
  top: 44px * @375;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9995;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;
  &-inner {
    padding: 12px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  &-hd {
    display: flex;
  }
  &-title {
    flex: 1;
    font-size: 14px;
  }
  &-delete {
    font-size: 20px;
  }
  &-bd {
    font-size: 12px;
    margin-top: 6px;
    margin-left: -2px;
    margin-bottom: 5px;
    > span {
      display: inline-block;
      line-height: 24px;
      border-radius: 12px;
      padding-left: 10px;
      padding-right: 10px;
      margin: 4px;
      max-width: 180px;
      background-color: #f7f7f7;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  &-searchFind {
    font-size: 12px;
    margin-top: 6px;
    margin-left: -2px;
    margin-bottom: 5px;
    > span {
      display: inline-block;
      line-height: 24px;
      border-radius: 12px;
      padding-left: 10px;
      padding-right: 10px;
      margin: 4px;
      max-width: 180px;
      background-color: #f7f7f7;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .searchFind-FirstType {
      background-color: rgba(247, 94, 53, 0.1);

      img {
        width: 14px;
        height: 14px;
        position: relative;
        top: -1px;
        vertical-align: middle;
      }
    }
    .searchFind-Second {
      background-color: rgba(61, 150, 226, 0.1);
      img {
        width: 14px;
        height: 14px;
        position: relative;
        top: -1px;
        vertical-align: middle;
      }
    }
    .recommandGoods {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .goods-item {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        margin-right: 9px;
        &:nth-child(5n) {
          margin-right: 0;
        }
        .img {
          width: 52px;
          height: 52px;
          margin-bottom: 5px;
          background: RGBA(247, 247, 247, 1);
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
.limitTwo {
  max-height: 70px;
  overflow: hidden;
}
</style>
